// extracted by mini-css-extract-plugin
export default {"panel":"Cards_panel__Y7R71","title":"Cards_title__whZiz","arrows":"Cards_arrows__uy2RF"};